// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__VhgXG","savePackageButton":"ClientWallet_savePackageButton__1wggW"};